import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highstock";
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography, useTheme } from "@mui/material";
import { useGetAdvancePaymentQuery } from "store/slices/apis/paymentTrackerSlice";
import { FaSquareFull } from "react-icons/fa6";
import { useParams } from "react-router-dom";

const StatusOfInvoice = () => {
    const theme = useTheme();
    const { projectId } = useParams();

    const { data } = useGetAdvancePaymentQuery({ projectId });

    const moduleColorMap = {
        'Advance Payment': '#E72B33',
        'Total Deduction': '#295477',
    };

    const mainData = data?.data || {};


    const graphdata = [
        {
            label: "Advance Payment",
            count: Number((mainData?.advancepaymentDetail ?? 0).toFixed(2))
        },
        {
            label: "Total Deduction",
            count: Number((mainData?.totalDeduction ?? 0).toFixed(2))
        }
    ];

    const totalCount = graphdata.reduce((sum, item) => sum + item.count, 0);

    const openIssuesData = graphdata.map(item => {
        const count = item.count;
        return {
            y: count,
            value: count,
            color: moduleColorMap[item.label],
            name: item.label,
            percentage: totalCount ? (count / totalCount) * 100 : 0,
        };
    });

    const options = {
        chart: {
            type: "pie",
            width: 180,
            height: 180,
            marginBottom: 10,
            marginRight: 0,
            marginLeft: 10,
        },
        title: {
            text: "",
            style: {
                fontWeight: 700,
                fontSize: '28px',
                color: '#000000',
                lineHeight: '100%'
            },
            align: 'center',
            verticalAlign: 'middle',
            y: 20,
        },
        subtitle: {
            useHTML: true,
            text: '',
            align: 'center',
            verticalAlign: 'middle',
            style: { fontSize: "14px", fontWeight: "400", color: "#000000", lineHeight: "100%" },
            y: 25,
            x: 0
        },
        credits: {
            enabled: false
        },
        tooltip: {
            formatter: function () {
                return `<b style='color: ${this.color}'>${this.name}</b>: ${this.y}`;
            }
        },
        plotOptions: {
            pie: {
                allowPointSelect: false,
                borderWidth: 0,
                borderRadius: 0,
                cursor: "pointer",
                innerSize: 70,
                dataLabels: {
                    enabled: false,
                },
                showInLegend: false,
            }
        },
        series: [
            {
                name: "",
                dataLabels: {
                    verticalAlign: 'top',
                    enabled: true,
                    style: {
                        fontWeight: 600,
                        fontSize: '11px',
                        color: '#FFFFFF',
                        lineHeight: '40px',
                        textOutline: 'none',
                    },
                    distance: -16,
                    formatter: function () {
                        return Math.round(this.percentage) + '%';
                    }
                },
                data: openIssuesData,
            }
        ]
    };

    return (
        <Box sx={{
            p: 2,
            width: "100%",
            height: "100%",
            maxWidth: "100%",
            border: "1px solid #D8D8D8",
            borderRadius: "12px",
            overflow: "hidden",
            backgroundColor: "white",
            // display: 'flex',
            // flexDirection: 'column'
        }}>
            <Box sx={{ flexShrink: 0 }}>
                <Typography variant="body" sx={{ fontWeight: 500, fontSize: "18px", lineHeight: "100%", letterSpacing: '-0.4px', color: `${theme?.customSettings?.themeColor}`, }}>
                    Advance Payment (in Cr)
                </Typography>
                {/* <Typography sx={{ mt: "5px", color: "#5052588A", fontWeight: 500, fontSize: "14px", lineHeight: "100%", letterSpacing: '-0.4px' }}>
                    Get a holistic view of how work is being prioritized
                </Typography> */}
            </Box>

            <Box sx={{
                flexGrow: 1,
                display: "flex",
                justifyContent: "space-between",
                flexDirection: { xs: "column", md: "row" },
                alignItems: "center",
                overflow: 'hidden',
                gap: 2,
                mt: 2
            }}>
                {openIssuesData.length === 0 ? (
                    <Box sx={{ width: '100%', textAlign: 'center', py: 4 }}>
                        <Typography variant="body1" color="textSecondary">
                            No data available to display the chart.
                        </Typography>
                    </Box>
                ) : (
                    <>
                        <List sx={{
                            padding: 0,
                            mb: { xs: 1, md: "12px" },
                            mb: "12px",
                            flex: '1 1 auto',
                            overflow: 'auto',
                            maxHeight: '100%',
                            width: { xs: '100%', md: 'auto' },
                            textAlign: { xs: 'center', md: 'left' }
                        }}>
                            {openIssuesData.map((val, index) => (
                                <ListItem key={index} sx={{ paddingLeft: 0, justifyContent: { xs: 'center', md: 'flex-start' },alignItems: { xs: 'center', md: 'baseline' }, }}>
                                    <ListItemIcon sx={{ minWidth: '20px' }}>
                                        <FaSquareFull style={{ color: val.color, height: '14px', width: '14px' }} />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={
                                            <>
                                                <Typography component="span" sx={{ fontWeight: 500, fontSize: "16px", letterSpacing: "-0.4px" }}>
                                                    {val.name}:{' '}
                                                </Typography>
                                                <Typography component="span" sx={{ fontWeight: 500, fontSize: "16px", color: "#182A4E" }}>
                                                    {val?.value.toFixed(2)}
                                                </Typography>
                                            </>
                                        }
                                    />
                                </ListItem>
                            ))}
                        </List>

                        <Box sx={{
                            flexShrink: 0,
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: { xs: '100%', md: 'auto' },
                            mt: { xs: 2, md: 0 }
                        }}>
                            <HighchartsReact highcharts={Highcharts} options={options} />
                        </Box>
                    </>
                )}
            </Box>
        </Box>
    );
};

export default StatusOfInvoice;
